import { jsx as _jsx } from "react/jsx-runtime";
import { Box, Typography, useTheme } from '@mui/material';
import { useEffect, useMemo, useState } from 'react';
import { DataGrid } from '@mui/x-data-grid';
import { getStudies } from '../../../api';
export const CreativeTable = (props) => {
    const { filterString, handleRowClick } = props;
    const theme = useTheme();
    const [studies, setStudies] = useState([]);
    const [loading, setLoading] = useState(true);
    const [paginationModel, setPaginationModel] = useState({
        page: 0,
        pageSize: 10,
    });
    const filteredStudies = useMemo(() => {
        if (!filterString)
            return studies;
        const q = filterString.toLowerCase().trim();
        return studies.filter(({ name, mediaType }) => (name !== null && name !== void 0 ? name : '').toLowerCase().includes(q) ||
            (mediaType !== null && mediaType !== void 0 ? mediaType : '').toLowerCase().includes(q));
    }, [studies, filterString]);
    useEffect(() => {
        setLoading(true);
        getStudies()
            .then(response => {
            setStudies(response.data);
            setLoading(false);
        })
            .catch(error => {
            console.error('Error fetching studies:', error);
            setLoading(false);
        });
        setStudies(studies);
    }, []);
    useEffect(() => {
        setPaginationModel((prev) => (Object.assign(Object.assign({}, prev), { page: 0 })));
    }, [filterString]);
    const columns = [
        {
            field: 'name',
            headerName: 'Study Name',
            cellClassName: 'name',
            flex: 0.6,
            renderCell: (params) => (_jsx(Typography, { sx: {
                    display: 'flex',
                    height: '100%',
                    alignItems: 'center',
                    color: theme.palette.text.primary,
                }, children: params.value })),
        },
        {
            field: 'runDate',
            headerName: 'Run Date',
            flex: 0.6,
            cellClassName: 'runDate',
            align: 'left',
            headerAlign: 'left'
        },
        {
            field: 'preview',
            headerName: 'Preview',
            flex: 0.8,
            cellClassName: 'preview',
            align: 'left',
            headerAlign: 'left',
        },
        {
            field: 'mediaType',
            headerName: 'Type',
            flex: 0.8,
            cellClassName: 'type',
            align: 'left',
            headerAlign: 'left',
        },
    ];
    return (_jsx(Box, { children: _jsx(DataGrid, { onRowClick: (params) => handleRowClick === null || handleRowClick === void 0 ? void 0 : handleRowClick(params.row.id), rows: filteredStudies, sortingOrder: ['asc', 'desc'], rowCount: filteredStudies.length, initialState: {
                sorting: {
                    sortModel: [{ field: 'id', sort: 'desc' }],
                },
            }, columns: columns, paginationModel: paginationModel, onPaginationModelChange: setPaginationModel, loading: loading, checkboxSelection: true, rowSelectionModel: undefined, onRowSelectionModelChange: undefined, sx: {
                background: 'white',
                height: '80vh',
                padding: '10px 15px',
                overflowY: 'scroll',
                '& > *': {
                    fontSize: '13px',
                },
                '& .reportName': {
                    color: theme.palette.primary.main,
                    textDecoration: 'underline',
                },
                '.MuiDataGrid-cell:focus': {
                    outline: 'none',
                },
                '& .MuiDataGrid-row:hover': {
                    cursor: 'pointer',
                },
            } }) }));
};
